'use strict';

module.exports = comment;

function comment(h, node) {
  return h(node, 'html', '<!--' + node.value + '-->');
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/comment.js
// module id = 1017
// module chunks = 0